import {accountPrefix} from '../routing.consts';
import type {PathParamDef, QueryParamDef, RouteDef} from '../routing.types';

// Extract the account parameter name from accountPrefix (e.g., ':accountId' from '/acc/:accountId')
const accountParamMatch = accountPrefix.match(/:(\w+)/);
const accountParamName = accountParamMatch ? accountParamMatch[1] : null;

function routeDef({
  path,
  displayName = '',
  pathParams = [],
  queryParams = [],
}: {
  path: string;
  displayName?: string;
  pathParams?: PathParamDef[];
  queryParams?: QueryParamDef[];
}): RouteDef {
  if (accountParamName) {
    // Validate that path doesn't contain the account parameter
    if (path.includes(`:${accountParamName}`)) {
      throw new Error(
        `Route definition error: Path "${path}" contains ":${accountParamName}" parameter. ` +
          `This parameter is added automatically via accountPrefix ("${accountPrefix}") and should not be included in route definitions.`,
      );
    }

    // Validate that pathParams doesn't include the account parameter
    const hasAccountParam = pathParams.some((param) => param.key === accountParamName);

    if (hasAccountParam) {
      throw new Error(
        `Route definition error: pathParams contains "${accountParamName}" parameter. ` +
          `This parameter is added automatically via accountPrefix ("${accountPrefix}") and should not be included in route definitions.`,
      );
    }
  }

  return {
    path,
    displayName,
    pathParams,
    queryParams,
  };
}

export default routeDef;
